
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When blockquote is used for testimonials or to emphasize excerpts of text. It is regarded as a standalone design component with a dominant appearance in the page.`}</p>
    <h3>{`When to use it`}</h3>
    <p>{`This is used for testimonials where organizations present quotes from someone prominent.`}</p>
    <h3>{`When not to use it`}</h3>
    <p>{`When indent a block of text.`}</p>
    <h3>{`Style`}</h3>
    <p>{`The layout of the blockquote is left aligned alongside the yellow bar. The text for the quotation or testimonial should be limited to three or four lines. Author of the quote should appear below the text.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;